import React, { useCallback, useMemo, useState } from "react";
import ExpandableCell from "../../../components/ExpandableCell";
import { COLORS } from "../constants";
import "../styles.css";
import { DbrResult, LoanOffer } from "../types";
import { calculateAge } from "../hook/API";
import { isoToLocalYYYYMMDD } from "../hook/ScreenHelper";

const NATIONAL_HEADERS = [
  "National ID",
  "Mobile No",
  "Requested Loan Amount",
  "Eligible Amount",
  "Eligible tenure",
  "Nationality",
  "Date of Birth",
  "Age",
  "Sector",
  "Status",
  "View More Info",
];
// const NATIONAL_DATA = [
//   {
//     "National ID": "-",
//     "Mobile No": "-",
//     "Requested Loan Amount": "-",
//     "Eligible Amount": "-",
//     "Eligible tenure": "-",
//     Nationality: "-",
//     "Date of Birth": "-",
//     Age: "-",
//     Sector: "-",
//     Status: "-",
//     "View More Info": "-",
//   },
// ];

interface EligibilityDataViewProps {
  userDetails?: any;
  nationalId?: string;
  sector?: string;
  dbr?: DbrResult;
  requestedLoan?: string;
  orderStatus?: string;
  maxAllowedLoan?: string;
  tenure?: string;
  racResult?: any;
  createdOn?: string;
  offer?: LoanOffer[];
  rejectionReason?: string;
}

const EligibilityDataView: React.FC<EligibilityDataViewProps> = ({
  userDetails,
  nationalId,
  sector,
  dbr,
  requestedLoan,
  orderStatus,
  racResult,
  createdOn,
  offer,
  rejectionReason
}) => {
  const [showMore, setShowMore] = useState(false);

  const age = calculateAge(userDetails?.dateOfBirth || '');
  // const failureReason =
  // racResult && Array.isArray(racResult) && racResult.length > 0
  //   ? racResult[0]?.FailureReason ?? '-'
  //   : '-';
  const createdOnDate = isoToLocalYYYYMMDD(createdOn);

  const lastObject = offer?.length ? offer[offer.length - 1] : undefined;

const nationalData = useMemo(() => {
  if (!userDetails) {
    return [];
  }
  return [
    {
      "National ID": nationalId?? "-",
      "Mobile No": userDetails?.mobileNumber ?? "-",
      "Requested Loan Amount": requestedLoan ?? "-",
      "Eligible Amount": lastObject?.Principal_max ?? "-" ?? "-",
      "Eligible tenure": lastObject?.tenure ?? "-" ?? "-",
      Nationality: userDetails?.nationality ?? "-",
      "Date of Birth": userDetails?.dateOfBirth ?? "-",
      Age: age ?? "-",
      Sector: sector || dbr?.sector || "-",
      Status: orderStatus ?? "-",
      "View More Info": "View Details",
    },
  ];
}, [userDetails, dbr, orderStatus]);


  const onClick = useCallback(() => {
    setShowMore((prev) => !prev);
  }, []);

  return (
    <div className="container mt-4">
      <p
        className="text-dark m-0"
        color="#1A2217"
        style={{
          fontFamily: "Cairo",
          fontWeight: 500,
          fontSize: "22px",
          //   lineHeight: "135%",
          letterSpacing: "0",
        }}
      >
        Eligibility Data
      </p>
      <hr />
      <table className="table text-center table-border spaced-table">
        {/* HEADER */}
        <thead style={{ background: "#F8F8F8" }}>
          <tr style={{ color: COLORS.TEXT_MUTED }}>
            {NATIONAL_HEADERS.map((header) => (
              <th key={header}>{header}</th>
            ))}
          </tr>
        </thead>

        {/* BODY */}
        <tbody style={{ color: COLORS.TEXT_MUTED, fontSize: "small" }}>
          {nationalData.map((row, i) => (
            <tr key={i}>
              {NATIONAL_HEADERS.map((header) =>
                header === "View More Info" ? (
                  <td key={header}>
                    <div
                      className="my-2 py-1"
                      style={{
                        border: "1px solid #D0D5DD",
                        borderRadius: 10,
                        fontSize: "14px",
                        cursor: "pointer",
                      }}
                      onClick={onClick}
                    >
                      {"View Details"}
                    </div>
                  </td>
                ) : (
                  <td key={header}>
                    <div className="my-2" style={{ fontSize: "14px" }}>
                      {row[header]}
                    </div>
                  </td>
                )
              )}
            </tr>
          ))}
        </tbody>
      </table>
      {showMore && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{ background: "rgba(0,0,0,0.4)", zIndex: 9999 }}
        >
          <div
            className="bg-white p-3 rounded shadow"
            style={{
              width: "80%",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <div className="d-flex flex-row align-items-center justify-content-between">
              <h5 className="mb-0" style={{ color: COLORS.TEXT_PRIMARY }}>
                Eligibility Data
              </h5>

              <button className="btn d-flex p-2 text-dark" onClick={onClick}>
                <i
                  className="bi bi-x-lg text-dark"
                  style={{ color: COLORS.TEXT_PRIMARY }}
                ></i>
              </button>
            </div>

            <div className="container mt-3">
              <table className="table text-center w-100 action-history-table table-border">
                <thead
                  className="table-head"
                  style={{ background: COLORS.BG_LIGHTER }}
                >
                  <tr style={{ color: COLORS.TEXT_MUTED }}>
                    <th>National ID</th>
                    <th>Mobile Number</th>
                    <th>Request Loan Amount</th>
                    <th>Eligible Amount</th>
                    <th>Eligible Tenure</th>
                    <th>Nationality</th>
                    <th>Date of Birth</th>
                    <th>Age</th>
                    <th>Number of dependents</th>
                    <th>Sector</th>
                  </tr>
                </thead>
                <tbody style={{ color: COLORS.TEXT_MUTED, fontSize: "medium" }}>
                  <tr>
                    <td>{nationalId ?? '-'}</td>
                    <td>{userDetails?.mobileNumber ?? '-'}</td>
                    <td>{requestedLoan ?? "-"}</td>
                    <td>{lastObject?.Principal_max ?? "-"}</td>
                    <td>{lastObject?.tenure ?? "-"}</td>
                    <td>{userDetails?.nationality ?? '-'}</td>
                    <td>{userDetails?.dateOfBirth ?? '-'}</td>
                    <td>{age ?? "-"}</td>
                    <td>{userDetails?.dependents?.totalDependents || 0}</td>
                    <td>{sector || dbr?.sector || "-"}</td>
                  </tr>
                </tbody>
              </table>

              <table className="table text-center w-100 action-history-table table-border">
                <thead
                  className="table-head"
                  style={{ background: COLORS.BG_LIGHTER }}
                >
                  <tr style={{ color: COLORS.TEXT_MUTED }}>
                    <th>Current Employer joining</th>
                    <th>Last Salary Received Date</th>
                    <th>Net Salary</th>
                    <th>Any Existing Monthly Commitment</th>
                    <th>Existing Monthly Commitment</th>
                    <th>Remaining Month</th>
                    <th>Segment</th>
                    <th>Status</th>
                    <th>Rejection Reason</th>
                    <th>Created on</th>
                  </tr>
                </thead>
                <tbody style={{ color: COLORS.TEXT_MUTED, fontSize: "medium" }}>
                  <tr>
                    <td>{"-"}</td>
                    <td>{"-"}</td>
                    <td>{dbr?.netIncome ?? '-'}</td>
                    <td>{"-"}</td>
                    <td>{"-"}</td>
                    <td>{"-"}</td>
                    <td>{"-"}</td>
                    <td className="status-eligible">{orderStatus ?? "-"}</td>
                    <ExpandableCell text={rejectionReason ?? undefined} />
                    <td>
                    {createdOnDate ?? "-"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EligibilityDataView;
